export default __webpack_public_path__ + "static/media/partners-logo-omnifit-w.cd45ed01.png";